import React, { useState } from 'react'

const FOLDER_ORDER = ['pipeline', 'stories']
const SCORE_COLOR = { A: '#7fc97f', B: '#58a6ff', C: '#e8c47f', D: '#e8a07f', F: '#ff8888' }
const STATUS_DOT = { queued: '#e8c47f', evaluated: '#7fc97f', evaluating: '#58a6ff' }

function groupByFolder(files) {
  const groups = { _root: [] }
  for (const f of files) {
    const parts = f.path.split('/')
    if (parts.length === 1) {
      groups._root.push(f)
    } else {
      const folder = parts[0]
      if (!groups[folder]) groups[folder] = []
      groups[folder].push(f)
    }
  }
  return groups
}

function displayName(f) {
  const fm = f.frontmatter || {}
  // Pipeline items: show "company — title"
  if (fm.company || fm.title) {
    const parts = [fm.company, fm.title].filter(Boolean)
    return parts.join(' \u2014 ')
  }
  // Stories: show title from _data
  if (f._data?.title) return f._data.title
  // Fallback to filename
  return f.path.split('/').pop()
}

export function FileTree({ files, selected, onSelect }) {
  const [collapsed, setCollapsed] = useState({})
  const groups = groupByFolder(files)

  const toggle = (folder) => setCollapsed(c => ({ ...c, [folder]: !c[folder] }))

  const queueCount = (groups.pipeline || []).filter(f => f.frontmatter?.status === 'queued').length

  return (
    <div className="vault-tree">
      {/* Root files (profile.md) */}
      {groups._root.map(f => (
        <div
          key={f.path}
          className={`vault-file-row${selected === f.path ? ' active' : ''}`}
          onClick={() => onSelect(f.path)}
        >
          <span className="vault-file-icon">{'\u{1F464}'}</span>
          {f.path.split('/').pop()}
        </div>
      ))}

      {/* Folders in order */}
      {FOLDER_ORDER.map(folder => {
        const items = groups[folder] || []
        return (
          <div key={folder}>
            <div className="vault-folder-header" onClick={() => toggle(folder)}>
              <span className="vault-folder-arrow">{collapsed[folder] ? '\u25B6' : '\u25BC'}</span>
              {folder}/
              <span className="vault-folder-count">
                {items.length}
                {folder === 'pipeline' && queueCount > 0 && (
                  <span className="vault-folder-queue-badge">{queueCount} queued</span>
                )}
              </span>
            </div>
            {!collapsed[folder] && items.map(f => (
              <div
                key={f.path}
                className={`vault-file-row vault-file-row--nested${selected === f.path ? ' active' : ''}`}
                onClick={() => onSelect(f.path)}
              >
                {/* Status dot for pipeline items */}
                {f.frontmatter?.status && STATUS_DOT[f.frontmatter.status] && (
                  <span className="vault-file-status-dot" style={{ background: STATUS_DOT[f.frontmatter.status] }} />
                )}
                <span className="vault-file-name">{displayName(f)}</span>
                {f.frontmatter?.score_letter && (
                  <span className="vault-file-badge" style={{ color: SCORE_COLOR[f.frontmatter.score_letter] }}>
                    {f.frontmatter.score_letter}
                  </span>
                )}
              </div>
            ))}
          </div>
        )
      })}
    </div>
  )
}
